// extracted by mini-css-extract-plugin
export default {"outer_container":"SocialShare_outer_container__Uy8Mg","container":"SocialShare_container__KCOCu","share_text":"SocialShare_share_text__3ajAL"};